import React, { memo, Suspense } from 'react';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import { Loader } from 'common/designSystem/loader/loader';

const Form = React.lazy(() => import('features/form/routes'));

const WebRoutes = () => {
  return (
    <Suspense fallback={<Loader width="100" className="loading-img" />}>
      <Router>
        <Routes>
          <Route path="/*" element={<Form />} />
        </Routes>
      </Router>
    </Suspense>
  );
};

export default memo(WebRoutes);
